import { createDataWidget } from "@/widgets/common/createDataWidget";
import { mockFetch } from "@/widgets/common/mockFetch";
import { generatePrintColorRecords } from "../shared/records";
import type { PrintColorRecord } from "../shared/records";

/**
 * Widget state via the shared factory (D11). The slice stores the SHARED
 * per-(color, width) records — the same source the PaperUsage widget
 * aggregates per paper width; aggregation per color happens in `logic.ts`.
 * Swapping in CubeJS replaces `mockFetch` with a real fetcher.
 */
export const printedColorUsage = createDataWidget<PrintColorRecord, void>({
  name: "printedColorUsage",
  fetcher: mockFetch(() => generatePrintColorRecords()),
});
